/**
 * Constants for progress line components
 * Centralizes all magic numbers, timing values, and configuration
 */

export const PROGRESS_LINE_CONSTANTS = {
  // Positioning & Layout
  VERTICAL_POSITION: '24%',
  HEIGHT: 6,
  BORDER_RADIUS: 10,

  // Mobile Layout
  MOBILE: {
    LEFT_OFFSET: 75, // px
    SEGMENT_WIDTH: 150, // px per segment
  },

  // Animations & Timing
  TRANSITIONS: {
    DURATION: '0.6s',
    EASING: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  },

  ANIMATIONS: {
    BACKGROUND_ENTRANCE: {
      DURATION: '2.5s', // Slower for more elegant entrance
      EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
    },
    COMPLETED_FILL: {
      DURATION: '2.4s', // Slower to appreciate node animations
      EASING: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },
    CURRENT_FILL: {
      DURATION: '2.4s', // Slower to appreciate node animations
      DELAY: '2.4s', // Start after completed fill finishes (updated to match new duration)
      EASING: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },
    ERROR_FILL: {
      DURATION: '2.4s', // Same duration as current fill for consistency
      DELAY: '2.4s', // Same delay as current fill for consistency
      EASING: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },
    SHINE: {
      DURATION: '3s',
      DELAY: '2.4s', // Updated to match new completed fill duration
      EASING: 'ease-in-out',
    },
    PULSE: {
      NORMAL: {
        DURATION: '1.5s',
        DELAY: '1.5s',
        EASING: 'ease-in-out',
      },
      ERROR: {
        DURATION: '1s',
        DELAY: '1.5s',
        EASING: 'ease-in-out',
      },
    },
    GLOW: {
      DURATION: '2s',
      DELAY: '1.5s',
      EASING: 'ease-in-out',
    },
    ERROR_BLINK: {
      DURATION: '0.8s',
      DELAY: '1.5s',
      EASING: 'ease-in-out',
    },
  },

  // Visual Effects
  SHADOWS: {
    GLOW_BLUR: 10, // px
    ACTIVE_BLUR: 15, // px
  },

  // Pseudo-element Positioning
  PSEUDO_OFFSET: -1, // px for ::before/::after positioning
  PSEUDO_BORDER_RADIUS: 11, // Slightly larger than main element

  // Scale Factors
  SCALE: {
    NORMAL_PULSE: 1.1,
    ERROR_PULSE: 1.15,
    BRIGHTNESS_ERROR: 1.2,
  },

  // Opacity Values
  OPACITY: {
    GLOW_MIN: 0.3,
    GLOW_MAX: 0.8,
    ERROR_BLINK_MIN: 0.4,
    ERROR_BLINK_MAX: 1,
    SHADOW_NORMAL: '20', // Appended to color for rgba
    SHADOW_ACTIVE: '30',
    SHADOW_ERROR: '40',
    SHINE_NORMAL: '40',
    GLOW_NORMAL_MIN: '20',
    GLOW_NORMAL_MAX: '60',
    GLOW_ERROR_MIN: '30',
    GLOW_ERROR_MAX: '70',
  },
} as const;
